import { Component, Input } from '@angular/core';
import { EventInfoWithConsentResponse } from '@ent-regis/entregis-ts-angular';

@Component({
  selector: 'app-investor-hotel',
  templateUrl: './investor-hotel.component.html',
  styleUrls: ['./investor-hotel.component.scss']
})
export class InvestorHotelComponent{

  @Input() event: EventInfoWithConsentResponse;
}
